export function decodeHtmlEntities(s: string): string {
  const el = document.createElement("textarea");
  el.innerHTML = s;
  return el.value;
}

export function centerOf(el: HTMLElement) {
  const r = el.getBoundingClientRect();
  return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
}

export function scrollWindowToElTop(
  el: HTMLElement,
  opts?: { offset?: number; behavior?: ScrollBehavior }
) {
  const behavior: ScrollBehavior = opts?.behavior ?? "smooth";
  const offset = opts?.offset ?? (window.innerWidth >= 1260 ? 130 : 95);

  const scroller = document.scrollingElement || document.documentElement;
  const rect = el.getBoundingClientRect();
  const targetTop = rect.top + window.scrollY - offset;
  const maxTop = (scroller.scrollHeight ?? 0) - window.innerHeight;
  const top = Math.max(0, Math.min(targetTop, maxTop));

  window.scrollTo({ top, left: 0, behavior });
}

export function freezeScrollDuring(mutator: () => void) {
  const scroller = document.scrollingElement || document.documentElement;
  const html = document.documentElement as HTMLElement;
  const prevBehavior = html.style.scrollBehavior;

  const y = scroller!.scrollTop;

  html.style.scrollBehavior = "auto";
  html.style.setProperty("overflow-anchor", "none");

  mutator();

  requestAnimationFrame(() => {
    scroller!.scrollTop = y;
    requestAnimationFrame(() => {
      html.style.scrollBehavior = prevBehavior || "";
      html.style.removeProperty("overflow-anchor");
    });
  });
}